// Global
import { FC } from 'react';

// Store
import { useAppState } from '@/store';

// Hooks
import { usePageValidations } from '../../../hooks/usePageValidations';

// Component
import { WideFormItem } from '../../../UpdatePage.styles';
import { ImageUpload } from '@/modules/Settings/components';
import { Input, InputLink, TextArea } from '@/ui';
import { useTranslation } from 'react-i18next';
import { VariableType } from 'src/shared/ui/VariablesDetector/VariableDetector.typedefs';
import { selectCurrentPage } from '@/modules/Pages/feature';

// Helpers
import { imagesSizesConfig } from '../../../../../utils/imagesSizesConfig';

interface UpdateContentLinkBlockProps {
  fieldName: string | number;
  registerInputRef: (fieldName: string, ref: any, type: VariableType) => void;
  handleInputChange: (fieldName: string, value: string) => void;
}

export const UpdateContentLinkBlock: FC<UpdateContentLinkBlockProps> = ({
  fieldName,
  handleInputChange,
  registerInputRef,
}) => {
  const { getRulesFor, getAcceptTypesFor } = usePageValidations();
  const { t } = useTranslation(['common']);
  const currentPage = useAppState(selectCurrentPage);

  if (!currentPage) return null;

  return (
    <>
      <WideFormItem
        label={t('update_page_form_content_link')}
        name={[fieldName, 'link']}
        rules={getRulesFor(['content', 'blocks', 'link'])}
      >
        <InputLink
          ref={(ref) =>
            registerInputRef(`${t('update_page_form_content_link')} [${+fieldName + 1}]`, ref, VariableType.INPUT)
          }
          onChange={(_, value) => handleInputChange(`${t('update_page_form_content_link')} [${+fieldName + 1}]`, value)}
          placeholder={t('update_page_form_content_link_placeholder')}
        />
      </WideFormItem>
      <WideFormItem
        label={t('update_page_form_content_description')}
        name={[fieldName, 'description']}
        rules={getRulesFor(['content', 'blocks', 'description'])}
      >
        <TextArea
          ref={(ref) =>
            registerInputRef(
              `${t('update_page_form_content_description')} [${+fieldName + 1}]`,
              ref,
              VariableType.TEXT_AREA,
            )
          }
          onChange={(e) =>
            handleInputChange(`${t('update_page_form_content_description')} [${+fieldName + 1}]`, e.target.value)
          }
          placeholder={t('update_page_form_content_description_placeholder')}
          rows={3}
        />
      </WideFormItem>

      <WideFormItem
        label={t('update_page_form_content_image')}
        name={[fieldName, 'image']}
        rules={getRulesFor(['content', 'blocks', 'image'])}
      >
        <ImageUpload
          accept={getAcceptTypesFor(['content', 'blocks', 'image'])}
          recommendedSize={imagesSizesConfig?.[currentPage.type]?.content}
        />
      </WideFormItem>

      <WideFormItem
        label={t('update_page_form_content_image_name')}
        name={[fieldName, 'imageName']}
        rules={getRulesFor(['content', 'blocks', 'imageName'])}
      >
        <Input
          onChange={(e) =>
            handleInputChange(`${t('update_page_form_content_image_name')} [${+fieldName + 1}]`, e.target.value)
          }
          ref={(ref) =>
            registerInputRef(`${t('update_page_form_content_image_name')} [${+fieldName + 1}]`, ref, VariableType.INPUT)
          }
          placeholder={t('update_page_form_content_image_name_placeholder')}
        />
      </WideFormItem>
    </>
  );
};
